import { getCookie } from '../cookie.js'
export const primaryMainNav = [
  {
    url: 'http://www.xdf.cn/',
    title: '首页'
  },
  {
    url: `http://souke.xdf.cn/Maps/${getCookie('soukecityid')}.html`,
    title: '校区'
  },
  // {
  //   url: `http://souke.xdf.cn/Teacher/${getCookie('soukecityid')}.html`,
  //   title: '教师'
  // },
  {
    url: 'http://xiaoxue.xdf.cn/list_1267_1.html',
    title: '学员'
  },
  {
    url: 'http://xiaoxue.xdf.cn/',
    title: '资讯'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/primary/mainnav.js